import { useRouter } from 'next/router';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'utils/i18n';

import ModalDialog from '../modal';

interface Props {
  onCheckout?: () => void;
  onClose?: () => void;
  isOpen?: boolean;
  children?: ReactNode;
}

const AddToBasketModal: FC<Props> = ({
  children,
  onCheckout = () => {},
  onClose: close = () => {},
  ...props
}) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const defaultChildren = children || <p>{t('quick_book.modal.message')}</p>;

  const checkout = () =>
    Promise.resolve(onCheckout()).then(() =>
      router.push(t('navigation.basket.url'))
    );

  return (
    <ModalDialog
      onClose={close}
      showCloseIcon
      headerLabel={t('quick_book.modal.header_label')}
      size="small"
      primaryAction={
        <button
          className="button button--primary button--medium"
          onClick={checkout}
        >
          {t('shared.checkout')}
        </button>
      }
      secondaryAction={
        <button
          className="button button--secondary button--medium"
          onClick={close}
        >
          {t('shared.continue_booking')}
        </button>
      }
      {...props}
    >
      <div className="icon icon--xlarge icon--success icon--centered">
        <i className="fas fa-check-circle" />
      </div>

      {defaultChildren}
    </ModalDialog>
  );
};

export default AddToBasketModal;
